import React from "react";
import FormSeguimientoCarga from "../components/CargoTracking/Form";
import ConnectedLogin from "../containers/ConnectedLogin";
import {
  LoginContainer,
  LoginContainerPanel,
} from "./../components/LoginContainer";
import "./LoginPage.scss";

const DISPLAY_CARGO_TRACKING_FORM =
  process.env.REACT_APP_DISPLAY_CARGO_TRACKING_FORM_ON_LOGIN_PAGE === "true";

export default class LoginPage extends React.Component {
  render() {
    // console.log("DISPLAY_CARGO_TRACKING_FORM: ", DISPLAY_CARGO_TRACKING_FORM);

    /*return (
            <Structure>
                <MainContainer centerContent>
                    <ConnectedLogin />
                </MainContainer>
            </Structure>
        );*/
    return (
      <div className="fullContainer">
        <div className="login-page-header">
          {/* <img src="/assets/img/login_header.png" alt="" /> */}
          <video 
            src="https://cdn.prod.website-files.com/69973777525e04c50e11a1e5%2F699a8685d2a9fcf88405aa9e_aerial-view-of-highway-with-vehicle-movement-at-ni-2026-01-21-15-39-51-utc_mp4.mp4" 
            controls={false}
            autoPlay
            loop
            muted
            playsInline
          >
            Your browser does not support the video tag.
          </video>
        </div>
        <div className="login-page-body">
          <LoginContainer>
            <LoginContainerPanel>
              <ConnectedLogin />
            </LoginContainerPanel>

            {DISPLAY_CARGO_TRACKING_FORM && (
              <LoginContainerPanel>
                <FormSeguimientoCarga />
              </LoginContainerPanel>
            )}
          </LoginContainer>
        </div>
      </div>
    );
  }
}
